// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, catálogo e o carregador da tela.
export { DASHBOARD_PATH, dashboardScreen } from './dashboard.screen';
export { loadDashboardMessages } from './dashboard.catalog';

/** A tela da rota (`DashboardRouteScreen`), por `lazyScreen`. */
export const loadDashboardScreens = () => import('./dashboard.page');

/** O guia da tela para o Luy (U46), sob demanda. */
export const loadDashboardGuides = () => import('./dashboard.guide');
